import { NavItems } from '@/components/layout/navigation/configNav';
import { useAppState } from '@/store/app-state';
import { useEffect } from 'react';

const useConsoleLayoutConfig = ({
  navConfig,
}: {
  navConfig: {
    title?: string;
    navbar?: NavItems;
    navbarFooter?: React.ReactNode;
  };
}) => {
  const { setConsoleLayoutConfig, resetConsoleLayoutConfig } = useAppState();
  useEffect(() => {
    setConsoleLayoutConfig({
      navConfig,
    });
    return () => {
      resetConsoleLayoutConfig();
    };
  }, [navConfig]);
};

export default useConsoleLayoutConfig;
